import { FilledButton } from '../components/common/Button';

import { IoMdCheckmarkCircleOutline } from 'react-icons/io';
import useRouting from '../hooks/useRouting';

export default function PricingPage() {

    const { goToExternalLink } = useRouting();

    const plans = [
        {
            name: 'À la carte',
            price: 499,
            interval: 'One-time',
            benefits: [
                '10 hour bundle',
                'Flexible, prepaid hours',
                'Access specialized creative talent',
                'Ideal for testing ideas',
            ],
            oneliner: 'Buy as many bundles as you need',
            stripeLink: 'https://buy.stripe.com/cN26q2dFw8566Oc4gm',
            highlight: false,
            cta: 'Buy Now'
        },
        {
            name: 'Starter',
            price: 1499,
            interval: 'monthly',
            benefits: [
                '40 hours/month',
                'Dedicated Project Manager',
                'Curated talent matching'
            ],
            stripeLink: 'https://buy.stripe.com/dR615I30S2KM2xWdQQ',
            highlight: false,
            cta: 'Subscribe'
        },
        {
            name: 'Team',
            price: 2999,
            interval: 'monthly',
            benefits: [
                '80 hours/month included',
                'Dedicated Project Manager',
                'Priority talent matching'
            ],
            stripeLink: 'https://buy.stripe.com/aEUg0C7h85WYgoM001',
            highlight: true,
            cta: 'Subscribe'
        },
        {
            name: 'Pro',
            price: 'Custom',
            interval: '',
            benefits: [
                'Customized hours and resources',
                'Premium support and onboarding',
                'Dedicated project management & talent sourcing',
                'Priority support and tailored solution'
            ],
            contactEmail: 'sales@gamershome.studio',
            highlight: false,
            cta: 'Email Us'
        }
    ]
    const planHighlightIndex = 2;

    return (
        <div className='max-w-7xl mx-auto p-4 mb-10'>
            <div className='my-10 flex flex-col items-center justify-center'>
                <h1 className='text-center max-w-2xl'>A suite of plans, tailored to your business needs</h1>
                <p className='mt-8 body1 text-center text-neutral-700 max-w-3xl'>Increase your creative project efficiency by up to 40% with Gamers Home</p>
                <p className='mt-2 caption1 max-w-2xl text-center'>Our platform simplifies your outsourcing by breaking ideas into clear tasks, sourcing specialized talent, and managing projects — saving you valuable time and resources.</p>
            </div>

            {/* Plans */}
            <div>
                <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4'>

                    {plans.map((plan, index) => (
                        <div className={`border border-neutral-300 p-8 rounded-xl relative flex flex-col ${index === planHighlightIndex ? 'border-primary shadow-lg' : ''}`} key={index}>
                            {plan.highlight && (
                                <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 bg-primary text-white px-4 py-1 rounded-full text-sm font-medium">
                                    Most Popular
                                </div>
                            )}
                            <h3 className='font-bold text-center'>{plan.name}</h3>
                            <p className='font-bold text-center text-primary'>{typeof plan.price === 'number'
                                ? `$${plan.price} ${plan.interval}`
                                : plan.price}</p>

                            {plan.oneliner && <p className='mt-4 text-center caption1'>{plan.oneliner}</p>}

                            <div className='flex-grow'>
                                <div className='w-fit mx-auto'>
                                    <div className='flex flex-col space-y-2 mt-4'>
                                        {plan.benefits.map((benefit, index) => (
                                            <div className='flex items-center gap-2'>
                                                <IoMdCheckmarkCircleOutline className='text-primary text-2xl' />
                                                <p key={index}>{benefit}</p>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>

                            {plan.stripeLink && <div className='mx-auto w-fit mt-8'>
                                <FilledButton onClick={() => goToExternalLink(plan.stripeLink)}>{plan.cta}</FilledButton>
                            </div>}

                            {plan.contactEmail && <div className='mx-auto w-fit mt-8'>
                                <FilledButton onClick={() => goToExternalLink(`mailto:${plan.contactEmail}`)}>{plan.cta}</FilledButton>
                            </div>}
                        </div>
                    ))}
                </div>
            </div>


        </div>
    );
}
